module.exports = __webpack_public_path__ + "img/blockSchedule.bcbcd0b1.svg";